import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

import ThemeConstants from '../../../../../../theme/ThemeConstants';

const styles = {
  container: {
    padding: '0 28px 28px',
  },
  field: {
    paddingY: '8px',
    borderBottom: `1px solid ${ThemeConstants.common.border}`,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
